import React from 'react';
import { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Col, Spinner, ModalFooter, ModalBody, FormGroup, Label, Input
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import auth from "authProvider";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { CountryDropdown } from 'react-country-region-selector';
import decodeJwt from 'jwt-decode';


export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(apiData, fileName)} style={{ padding: 6, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
  );
};




const Tenants = (props) => {
  const [tenants, setTenants] = useState(false);
  const [modalopen_deactivate, setModalopen_deactivate] = React.useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [searchterm, setSearchTerm] = useState('');
  const [newstatus, setNewstatus] = useState(0);
  const [statusnew, Setstatusnew] = useState(1);
  const [result, setResult] = useState();
  const [value, setValue] = useState(false);
  const [error, setError] = useState('');
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [exported, setExported] = useState([]);
  const [filter, setFilter] = useState(false);
  const [searchlocation, setSearchlocation] = useState(false);
  const [searchsublocation, setSearchsublocation] = useState(false);
  const [searchnationality, setSearchnationality] = useState(false);
  const [peropen, setPeropen] = useState(false)
  const [filtered_sublocation, setFiltered_sublocation] = useState(false);

  let per = localStorage.getItem('permission');
  const perModal = () => {
    setPeropen(true)
  }

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const history = useHistory();

  const handleModalClose_deactivate = () => {
    setModalopen_deactivate(false);
  };
  useEffect(() => {
    let token = localStorage.getItem('token');
    // let filter = {};
    // let filter = searchterm ? { fullname: searchterm } : false
    dataProvider.getList('tenants', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' } } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({ id: item.id, FullName: item.fullname, Email: item.email, Mobile: item.mobile, ElectricityNumber: item.electricity_number, DateAdded: item.dateAdded, Nationality: item.nationality, username: item.username }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setTenants(data);
        setSearchTerm('');
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
    dataProvider.getList('locations/list', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        setLocations(data[0].data);
      })
  }, [props, reload]);

  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };

  const removeData = (id, index) => {
    dataProvider.delete('tenants', { id: id });
    dataProvider.deleteManyWorkOrderByTenant('orders', { tenantId: id })
    let tenantArr = tenants;
    tenantArr.splice(index, 1);
    setTenants(tenantArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });

    // dataProvider.deleteManyWorkOrderByTenant('orders', { tenantId: id })
    //   .then(({ data }) => {
    //     console.log(data)
    //     let tenantArr = tenants;
    //     tenantArr.splice(index, 1);
    //     setTenants(tenantArr);
    //     setFlag(!flag)
    //     setConfirmOpen({ visible: false, id: null, index: null });

    //   })
    //   .catch(error => {
    //     console.log(error)
    //   });
  }
  const onSubmit = (values, id) => {
  };
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const searchFilter = () => {
    setPage(1);
    setReload(!reload);
    history.push('/tenants')

  }
  const click_deactivate = (id, status) => {
    setValue(id)
    if (status === 1) {
      dataProvider.update('tenants', { id: id, params: { status: newstatus } })
        .then(({ data }) => {
          setLoading(true)
          setModalopen_deactivate(true);
          history.push("/tenants");
        })
        .catch(error => {
          setLoading(false)
          alert(error.message)
        });
    } else {
      dataProvider.update('tenants', { id: id, params: { status: statusnew } })
        .then(({ data }) => {
          setLoading(true)
          history.push("/tenants");
        })
        .catch(error => {
          setLoading(false)
          alert(error.message)
        });
    }
  }
  const resultsubmit = () => {
    if (!result) {
      setError('Required')
    }
    dataProvider.update('tenants', { id: value, params: { reason: result } })
      .then(({ data }) => {
        setLoading(true)
        if (result) {
          setError('')
          setResult('')
          setModalopen_deactivate(false);
        }
      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });
  }
  const handleKeyPress = (event) => {
    let token = localStorage.getItem('token');
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    dataProvider.getList('tenants', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        setTenants(data)
      }).catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }
  const Openfilter = () => {
    setFilter(false)
    history.push('./tenants')
  }
  const Closefilter = () => {
    setFilter(true)
  }
  const Filter_dropdown = () => {
    setPage(1);
    // setReload(!reload);
    onFilterQuery();
  }
  const onFilterQuery = () => {
    console.log(filtered_sublocation);
    let token = localStorage.getItem('token');
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    // if (searchlocation) {
    //   filter.location = searchlocation;
    // }
    if (filtered_sublocation) {
      let fl = filtered_sublocation;
      delete (fl[0].children);
      filter.location = fl;
    }
    if (searchsublocation) {
      filter.sub_location = searchsublocation;
    }
    if (searchnationality) {
      filter.nationality = searchnationality;
    } console.log(filter)
    // let filter = searchterm ? { fullname: searchterm } : false
    dataProvider.getList('tenants', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({ id: item.id, FullName: item.fullname, Email: item.email, Mobile: item.mobile, ElectricityNumber: item.electricity_number, DateAdded: item.dateAdded, Nationality: item.nationality, username: item.username }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setTenants(data);
        setSearchTerm('')
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }
  if (!tenants) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }
  const Selected_locationchange = (val) => {
    setFiltered_sublocation(locations?.filter(item => (item._id === val)));

  }
  // console.log(per)
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.5rem' }}>TENANTS</h2>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                <Link to="/tenants/expire"><Button style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} > EXPIRING SOON</Button>{' '}</Link>
                {/* <Link to="/tenants/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>{' '}</Link> */}
                {per && per.includes('tenants_add') ? <Link to="/tenants/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>}
              </div>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                {filter ? <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Openfilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                  <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={14} icon="close" />FILTER</Button>{' '}
                </div> :
                  <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Closefilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                    <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="filter" />FILTER</Button>{' '}
                  </div>
                }
                <Col sm={6} style={{ padding: 0 }}>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit, form }) => (
                      <form
                        onSubmit={async event => {
                          await handleSubmit(event)
                          form.reset()
                        }}>
                        <div className="pl-lg-4">
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Field name="search">
                                  {({ input, meta, reset }) => (
                                    <div>
                                      <Input
                                        style={{ backgroundColor: '#E3F7F7' }}
                                        placeholder="Search Tenants"
                                        value={searchterm}
                                        onKeyUp={(e) => handleKeyPress(e.target.value)}
                                        onChange={(event) => { setSearchTerm(event.target.value) }}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <div style={{ position: 'absolute', right: 10 }}>
                              <Button onClick={() => searchFilter()} style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0 }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" /></Button>
                            </div>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col >
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                  <ExportToExcel apiData={exported} fileName="technicians" />
                </div>
              </CardHeader>
              {filter ?
                <Col>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit }) => (
                      <form onSubmit={handleSubmit}>
                        <Col lg="12">
                          <Row>
                            <Col lg="4" >
                              <FormGroup >
                                <div style={{ display: 'flex' }}>
                                  <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="loations"> </IcomoonReact></div>
                                  <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>Location</Label></div>
                                </div>
                                <Field name="location">
                                  {({ input, meta, value }) => (
                                    <div>
                                      <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" name="location" onChange={(event) => { Selected_locationchange(event.target.value) }}>
                                        <option value="">CHOOSE LOCATION</option>
                                        {locations && locations.map(item => (
                                          <option value={item._id}>{item.location} </option>
                                        ))}
                                      </Input>
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <Col lg="4" >
                              <FormGroup >
                                <div style={{ display: 'flex' }}>
                                  <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="loations"> </IcomoonReact></div>
                                  <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>SubLocation</Label></div>
                                </div>
                                <Field name="sublocation" >
                                  {({ input, meta, value }) => (
                                    <div>
                                      <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" name="sublocation" onChange={(e) => setSearchsublocation(e.target.value)}>
                                        <option value="">CHOOSE SUBLOCATION</option>
                                        {filtered_sublocation && filtered_sublocation.map(item => (
                                          <>
                                            {item.children && item.children.length > 0 && (
                                              item.children.map((child) => (
                                                <option value={child._id}>{child.location}</option>
                                              ))
                                            )}
                                          </>
                                        ))}
                                      </Input>
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            {/* <Col lg="4" >
                              <FormGroup >
                                <div style={{ display: 'flex' }}>
                                  <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="loations"> </IcomoonReact></div>
                                  <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>SubLocation</Label></div>
                                </div>
                                <Field name="sublocation" >
                                  {({ input, meta, value }) => (
                                    <div>
                                      <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" name="sublocation" onChange={(event) => { setSearchsublocation(event.target.value) }} >
                                        <option value="">CHOOSE SUBLOCATION</option>
                                        {locations && locations.length > 0 && (
                                          locations.map((item, index) => (
                                            <>
                                              {item.children && item.children.length > 0 && (
                                                item.children.map((child) => (
                                                  <option value={child._id}>{child.location}</option>
                                                ))
                                              )}
                                            </>
                                          )))}
                                      </Input>
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <Col lg="3">
                              <FormGroup >
                                <Label style={{ fontSize: ' 0.8125rem' }} for="nation">Nationality</Label>
                                <Field name="nationality" >
                                  {({ input, meta, value }) => (
                                    <div style={{ paddingLeft: 0 }}>
                                      <CountryDropdown
                                        style={{
                                          padding: '8px',
                                          width: '100%',
                                          borderRadius: '5px',
                                          borderColor: 'rgb(231 235 238)'
                                        }}
                                        value={searchnationality}
                                        onChange={(e) => setSearchnationality(e)} />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col> */}
                            <Col lg="1" style={{ marginTop: 30 }}>
                              <Button type="submit" onClick={() => Filter_dropdown()} style={{ backgroundColor: 'rgb(72 184 227)', color: 'white', border: 0, borderRadius: 5 }}>Apply</Button>
                            </Col>
                          </Row>
                        </Col>
                      </form>
                    )}
                  />
                </Col >
                : null}
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr style={{ textAlign: 'center' }}>
                    <th scope="col">
                      <FormGroup check style={{ paddingBottom: '20px' }}>
                        <Input type="checkbox" />{' '}
                      </FormGroup>
                    </th>
                    <th scope="col">USER</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">USERNAME</th>
                    <th scope="col">PHONE NUMBER</th>
                    <th scope="col">VILLA NO</th>
                    <th scope="col" >ACTION</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {!tenants || tenants.length < 1 ? (
                    <tr>
                      <td style={{ color: '#12ACF6', textAlign: 'center', padding: 20, margin: 20 }} colSpan={11}>No Results found
                        <IcomoonReact style={{ marginLeft: 10 }} iconSet={iconSet} color="#12ACF6" size={22} icon="search" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {tenants.map((item, index) => (
                        <tr style={{ textAlign: 'center' }}>
                          <th>
                            <FormGroup check style={{ paddingBottom: '20px' }}>
                              <Input type="checkbox" />{' '}
                            </FormGroup>
                          </th>
                          <td style={{ color: '#12ACF6', textTransform: 'capitalize' }}>{item.fullname}</td>
                          <td>{item.email}</td>
                          <td>{item.username}</td>
                          <td>{item.mobile}</td>
                          <td>{item.sub_location?.location}</td>
                          {/* <td>{item?.villa}</td> */}
                          {/* {item?.status === 1 && per?.includes('tenants_edit') && (
                            <td><Button onClick={() => click_deactivate(item.id, item.status)} style={{ backgroundColor: '#f1f2f2', fontSize: '0.625rem', boxShadow: 'none', padding: '6px 25px 6px 25px', borderRadius: '20px', border: 0, color: 'green' }} >ACTIVE</Button></td>
                          )}
                          {item?.status === 0 && per?.includes('tenants_edit')(<td><Button style={{ backgroundColor: '#f1f2f2', fontSize: '0.625rem', padding: '6px 22px 6px 22px', borderRadius: '20px', border: 0, color: 'red', boxShadow: 'none' }} onClick={() => click_deactivate(item.id, item.status)}>DEACTIVE</Button></td>)} */}

                          {item?.status === 1 ? <td><Button onClick={() => click_deactivate(item.id, item.status)} style={{ backgroundColor: '#f1f2f2', fontSize: '0.625rem', boxShadow: 'none', padding: '6px 25px 6px 25px', borderRadius: '20px', border: 0, color: 'green' }} >ACTIVE</Button></td> :
                            <td><Button style={{ backgroundColor: '#f1f2f2', fontSize: '0.625rem', padding: '6px 22px 6px 22px', borderRadius: '20px', border: 0, color: 'red', boxShadow: 'none' }} onClick={() => click_deactivate(item.id, item.status)}>DEACTIVE</Button></td>}
                          <td style={{ flexDirection: 'row', display: 'flex', verticalAlign: 'middle', padding: 5, margin: 0 }}>
                            {per && per.includes('tenants_edit') ?
                              <Link to={{ pathname: "/tenants/edit/", state: item.id }}>
                                <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 10, textAlign: 'center' }}><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>
                              </Link>
                              :
                              <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 10, textAlign: 'center' }}><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>}
                            {per && per.includes('tenants_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })}> <IcomoonReact iconSet={iconSet} color="#ccc" size={22} icon="delete" /></Button> :
                              <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}> <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button>}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </div>
        </Row>
      </Container >
      <Modal
        className="modal-dialog-centered"
        isOpen={modalopen_deactivate}
      >
        <div onClick={handleModalClose_deactivate} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-9px', top: '-10px', borderRadius: '50%' }}>
          <IcomoonReact iconSet={iconSet} onClick={handleModalClose_deactivate} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
        </div>
        <div className="modal-header">
          <h5 style={{ marginLeft: 15 }}>REASON FOR DEACTIVATION</h5>
        </div>
        <div>
          <Row>
            <Col md="12" style={{ padding: '20px', paddingLeft: '20px', paddingRight: '37px', paddingTop: 0 }}>
              <div className="pl-lg-4" >
                <Input
                  type="text"
                  name="reason"
                  placeholder="Reason for deactivation"
                  value={result ? result : ''}
                  style={{ color: 'black', padding: 40, height: 50 }}
                  onChange={(e) => setResult(e.target.value)}
                />
              </div>
              <span style={{ color: 'red', fontSize: '0.8rem', paddingLeft: 22 }}>{error}</span>
              <Col md="4" >
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                  <Button onClick={() => resultsubmit()} color={'white'} style={{ backgroundColor: 'rgb(0 139 183)', color: 'white', width: '100%', borderRadius: '10px' }} >
                    {/* <Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} /> */}
                    SUBMIT</Button>{' '}
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => setPeropen(false)} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Tenants;
